import getShorterText from "Common/componentUtils/getShorterText";
import { themeVariables } from "Components/theme";
import edgeSvg from "Content/images/graph/edge.svg";
import React, { useMemo } from "react";
const mainDataContainerStyle = {
    display: "grid",
    alignContent: "center"
};
const displayNameStyle = {
    paddingTop: 2,
    paddingBottom: 3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: themeVariables["line-height-medium"]
};
const idStyle = {
    fontSize: themeVariables["font-size-small"],
    color: themeVariables["gray-500"],
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingBottom: 2
};
const fromToDescriptionStyle = {
    fontSize: themeVariables["font-size-small"],
    color: themeVariables["gray-400"],
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: themeVariables["line-height-medium"]
};
const imgStyle = {
    borderRadius: "50%",
    objectFit: "cover",
    border: "0"
};
export default function EdgeLabel(props) {
    const labelRootStyle = useMemo(() => ({
        ...(props.style || {}),
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        gridTemplateRows: "1fr",
        boxSizing: "border-box"
    }), [props.style]);
    const imageContainerStyle = useMemo(() => props.imgSize
        ? {
            width: props.imgSize,
            height: props.imgSize,
            minHeight: props.imgSize,
            minWidth: props.imgSize,
            marginRight: 10,
            borderRadius: "50%",
            backgroundColor: themeVariables["gray-100"],
            display: "grid",
            alignContent: "center",
            justifyContent: "center"
        }
        : undefined, [props.imgSize]);
    if (!props.data)
        return null;
    return (React.createElement("div", { className: props.className, style: labelRootStyle },
        Boolean(props.imgSize) && (React.createElement("div", { style: imageContainerStyle },
            React.createElement("img", { src: edgeSvg, width: props.imgSize, height: props.imgSize, title: "", alt: "", style: imgStyle }))),
        !props.onlyIcon && (React.createElement("div", { style: mainDataContainerStyle },
            props.data.Name && (React.createElement("div", { style: displayNameStyle, title: props.data.Name }, getShorterText(props.data.Name, props.titleMaxLength))),
            React.createElement("div", { style: idStyle }, props.data.Id),
            props.from && props.to && (React.createElement("div", { style: fromToDescriptionStyle },
                React.createElement("span", null, props.from.Name),
                React.createElement("i", { className: "d-inline-block line-height-1 ml-0_5 mr-0_5 icon-arrow-down rotate-270" }),
                React.createElement("span", null, props.to.Name)))))));
}
EdgeLabel.defaultProps = {
    imgSize: 50,
    titleMaxLength: 100
};
